import { IInventoryItemsQueryParamsForStockMovement } from 'gen/ApiClient';

export const DefaultInventoryItemsQueryParamsForStockMovement: IInventoryItemsQueryParamsForStockMovement = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	categories: [],
	subcategories: [],
	forProductCatalogId: undefined,
	isShowAll: false,
};
